import { apiClient } from "../http/ApiClient";
import { API_ENDPOINTS } from "../../config/Constants";

export const ecommerce = {
  /**
   * Login para Superusuario Messiah (POST /user/messiah/session)
   */
  postSession: (requestBody) => {
    return apiClient.post(API_ENDPOINTS.USER.SESSION, requestBody, null);
  },
  deleteSession: (queryParams) => {
    return apiClient.delete(API_ENDPOINTS.USER.SESSION, { queryParams: queryParams });
  },

  getSdkReleases: (queryParams) => {
    return apiClient.get(API_ENDPOINTS.OPERATIONAL.SDKS, { queryParams: queryParams });
  },

  //#region CLIENTS
  getClients: (queryParams) => {
    return apiClient.get(API_ENDPOINTS.OPERATIONAL.USERS.CLIENTS, { queryParams: queryParams });
  },

  postClients: (requestBody) => {
    return apiClient.post(API_ENDPOINTS.OPERATIONAL.USERS.CLIENTS, requestBody, null);
  },

  patchClients: (requestBody) => {
    return apiClient.patch(API_ENDPOINTS.OPERATIONAL.USERS.CLIENTS, requestBody, null);
  },

  deleteClients: (queryParams) => {
    return apiClient.delete(API_ENDPOINTS.OPERATIONAL.USERS.CLIENTS, { queryParams: queryParams });
  },
  //#endregion

  //#region APPLICATIONS
  getApps: (queryParams) => {
    return apiClient.get(API_ENDPOINTS.OPERATIONAL.APPS, { queryParams: queryParams });
  },

  postApps: (requestBody) => {
    return apiClient.post(API_ENDPOINTS.OPERATIONAL.APPS, requestBody, null);
  },

  patchApps: (requestBody) => {
    return apiClient.patch(API_ENDPOINTS.OPERATIONAL.APPS, requestBody, null);
  },

  deleteApps: (queryParams) => {
    return apiClient.delete(API_ENDPOINTS.OPERATIONAL.APPS, { queryParams: queryParams });
  },
  //endregion

  //#region SERVICE ACCOUNTS
  getServiceAccounts: (queryParams) => {
    return apiClient.get(API_ENDPOINTS.OPERATIONAL.SERVICE_ACCOUNTS, { queryParams: queryParams });
  },
  postServiceAccounts: (requestBody) => {
    return apiClient.post(API_ENDPOINTS.OPERATIONAL.SERVICE_ACCOUNTS, requestBody, null);
  },
  deleteServiceAccounts: (queryParams) => {
    return apiClient.delete(API_ENDPOINTS.OPERATIONAL.SERVICE_ACCOUNTS, { queryParams: queryParams });
  },
  //#endregion
};